import { PropsWithChildren, ReactNode, RefObject } from 'react';

import { Crumb } from 'components/Breadcrumb';
import { Bar, TabBar } from 'components/Tabbar';

import { Header } from './containers/Header';
import { Navigation } from './containers/Navigation';

import * as S from './styles';

interface Props extends PropsWithChildren {
  title: string;
  button?: ReactNode;
  crumbs: Array<Crumb>;
  haveTabbar?: boolean;
  tabs?: Array<Bar>;
  backButtonRoute?: string | null;
  bodyRef?: RefObject<HTMLDivElement>;
  paddingBottom?: string;
}

export function MainWrapper({
  title,
  button,
  crumbs,
  backButtonRoute = '/',
  haveTabbar = false,
  paddingBottom,
  tabs,
  children,
  bodyRef,
}: Props) {
  return (
    <S.Container>
      <Navigation backButtonRoute={backButtonRoute} />

      <Header title={title} button={button} crumbs={crumbs}>
        {haveTabbar && tabs && <TabBar tabs={tabs} />}
      </Header>

      <S.Body
        ref={bodyRef}
        haveTabbar={haveTabbar}
        paddingBottom={paddingBottom}
      >
        {children}
      </S.Body>
    </S.Container>
  );
}
